import { ITimestampedEntity } from 'src/models/IEntity'
import IPipeline from 'src/models/IPipeline'
import IProfile from 'src/models/IProfile'

export enum JobType {
    PipelineConfig = 'PIPELINE_CONFIG',
    PipelineEnv = 'PIPELINE_ENV',
    PipelineRun = 'PIPELINE_RUN',
    PipelineVerify = 'PIPELINE_VERIFY',
    PipelineDiscover = 'PIPELINE_DISCOVER',
    WorkspaceInit = 'WORKSPACE_INIT',
    WorkspaceConfig = 'WORKSPACE_CONFIG',
    WorkspaceDeploy = 'WORKSPACE_DEPLOY'
}

export enum JobStatus {
    Skipped = 'SKIPPED',
    Complete = 'COMPLETE',
    Error = 'ERROR',
    Queued = 'QUEUED',
    Running = 'RUNNING',
    Stopped = 'STOPPED',
    // A failed run that a retry will follow: reported by the backend, never a raw task
    // outcome. The run's real verdict lands on the final attempt (MEL-568).
    Warning = 'WARNING'
}

export default interface IJob extends ITimestampedEntity {
    type: JobType
    triggeredBy?: string
    maxAttempts: number
    attempt: number
    exitCode?: number
    status: JobStatus
    commitId?: string
    startTime?: string
    endTime?: string
    _embedded: {
        pipeline?: IPipeline
        profile?: IProfile
    }
}
